import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GenerateBatchCodeResponse } from '../models/material/generate-batch-code-response.model';
import { MaterialWh } from '../models/material/material-wh.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';
import { MaterialDownloadRequest } from '../models/material/material-download-request.model';
import { MaterialWhUploadResult } from '../models/material/material-wh-upload-result.model';
import { MaterialWhDownloadUploadLogRequest } from '../models/material/material-wh-download-upload-log-request.model';
import { MaterialWhDownloadUploadTlRequest } from '../models/material/material-wh-download-upload-tl-request.model';

@Injectable({
  providedIn: 'root',
})
export class MaterialWhService extends RequestService<MaterialWh> {
  static PATH = '/material/wh';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService,
  ) {
    super(httpClient, MaterialWhService.PATH, globalService.debugUrl);
  }

  generateBatchNo(req: MaterialWh) {
    return this.httpClient.post<GenerateBatchCodeResponse>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${MaterialWhService.PATH}/generateBatchNo`,
      req,
    );
  }

  uploadExcel(file: File, sectionId: number, organizationId: number) {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('sectionId', sectionId.toString());
    formData.append('organizationId', organizationId.toString());
    formData.append('projectId', this.globalService.projectId.toString());
    return this.httpClient.post<MaterialWhUploadResult>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${MaterialWhService.PATH}/upload`,
      formData,
    );
  }

  download(req: MaterialDownloadRequest) {
    return fetch(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${MaterialWhService.PATH}/download`,
      {
        method: 'POST',
        body: JSON.stringify(req),
        headers: {
          token: this.globalService.token,
        },
      },
    );
  }

  downloadUploadErrorLog(req: MaterialWhDownloadUploadLogRequest) {
    return fetch(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${MaterialWhService.PATH}/downloadUploadErrorLog`,
      {
        method: 'POST',
        body: JSON.stringify(req),
        headers: {
          token: this.globalService.token,
        },
      },
    );
  }

  downloadUploadTl(req: MaterialWhDownloadUploadTlRequest) {
    return fetch(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${MaterialWhService.PATH}/downloadUploadTl`,
      {
        method: 'POST',
        body: JSON.stringify(req),
        headers: {
          token: this.globalService.token,
        },
      },
    );
  }

  updateQa(id: number, qaFileIds: string) {
    return this.httpClient.post(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${MaterialWhService.PATH}/updateQa`,
      {
        id,
        qaFileIds,
      },
    );
  }
}
